module.exports = __webpack_public_path__ + "img/exit.d7a6cbb0.svg";